export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		randomBattleMoves: ["hiddenpowerfire", "hiddenpowerice", "leechseed", "naturepower", "powerwhip", "sleeppowder", "sludgebomb", "swordsdance", "synthesis"],
		tier: "(OU)",
		doublesTier: "DOU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		randomBattleMoves: ["airslash", "dragonpulse", "fireblast", "focusblast", "hiddenpowergrass", "roost"],
		tier: "NU",
		doublesTier: "DOU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NU",
		doublesTier: "NFE",
	},
	blastoise: {
		randomBattleMoves: ["icebeam", "protect", "rapidspin", "scald", "toxic"],
		tier: "UU",
		doublesTier: "DUU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["bugbuzz", "hiddenpowerrock", "psychic", "quiverdance", "sleeppowder", "substitute"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		randomBattleMoves: ["drillrun", "poisonjab", "tailwind", "toxicspikes", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		randomBattleMoves: ["bravebird", "heatwave", "quickattack", "return", "roost", "uturn", "workup"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		randomBattleMoves: ["crunch", "facade", "flamewheel", "suckerpunch", "swordsdance", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		randomBattleMoves: ["doubleedge", "drillpeck", "drillrun", "pursuit", "quickattack", "return", "roost", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		randomBattleMoves: ["aquatail", "coil", "earthquake", "glare", "gunkshot", "rest", "seedbomb", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		randomBattleMoves: ["extremespeed", "grassknot", "hiddenpowerice", "thunderbolt", "voltswitch"],
		tier: "NFE",
	},
	raichu: {
		randomBattleMoves: ["encore", "focusblast", "grassknot", "hiddenpowerice", "nastyplot", "thunderbolt", "voltswitch"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["earthquake", "rapidspin", "stealthrock", "stoneedge", "swordsdance", "xscissor"],
		tier: "RU",
		doublesTier: "DUU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["earthpower", "fireblast", "icebeam", "sludgewave", "stealthrock", "toxicspikes"],
		tier: "UU",
		doublesTier: "DUU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["earthpower", "fireblast", "icebeam", "sludgewave", "substitute", "superpower"],
		tier: "UU",
		doublesTier: "DUU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		randomBattleMoves: ["calmmind", "doubleedge", "icebeam", "softboiled", "stealthrock", "thunderbolt", "thunderwave"],
		tier: "RU",
		doublesTier: "DUU",
	},
	vulpix: {
		tier: "NFE",
	},
	ninetales: {
		randomBattleMoves: ["fireblast", "nastyplot", "painsplit", "solarbeam", "substitute", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		randomBattleMoves: ["doubleedge", "fireblast", "healbell", "protect", "stealthrock", "toxic", "wish"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NU",
		doublesTier: "NFE",
	},
	crobat: {
		randomBattleMoves: ["bravebird", "heatwave", "roost", "sludgebomb", "superfang", "taunt", "toxic", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		randomBattleMoves: ["aromatherapy", "gigadrain", "hiddenpowerfire", "leechseed", "sleeppowder", "sludgebomb", "synthesis"],
		tier: "PU",
		doublesTier: "DUU",
	},
	bellossom: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "hiddenpowerrock", "leafstorm", "leechseed", "sleeppowder", "stunspore", "synthesis"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		randomBattleMoves: ["aromatherapy", "leechseed", "seedbomb", "spore", "stunspore", "synthesis", "xscissor"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		randomBattleMoves: ["bugbuzz", "quiverdance", "roost", "sleeppowder", "substitute"],
		tier: "RUBL",
		doublesTier: "DUU",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		randomBattleMoves: ["aerialace", "earthquake", "memento", "stealthrock", "stoneedge", "suckerpunch"],
		tier: "(OU)",
		doublesTier: "DUU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		randomBattleMoves: ["bite", "fakeout", "return", "switcheroo", "taunt", "uturn", "waterpulse"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["calmmind", "encore", "focusblast", "hydropump", "icebeam", "psyshock", "scald"],
		tier: "PU",
		doublesTier: "DUU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		randomBattleMoves: ["closecombat", "honeclaws", "icepunch", "stoneedge", "uturn"],
		tier: "NU",
		doublesTier: "DUU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		randomBattleMoves: ["closecombat", "extremespeed", "flareblitz", "hiddenpowergrass", "morningsun", "wildcharge", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		randomBattleMoves: ["bulkup", "circlethrow", "focuspunch", "rest", "sleeptalk", "substitute", "toxic", "waterfall"],
		tier: "RU",
		doublesTier: "DUU",
	},
	politoed: {
		randomBattleMoves: ["encore", "focusblast", "hiddenpowergrass", "hypnosis", "icebeam", "protect", "scald", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NU",
		doublesTier: "NFE",
	},
	alakazam: {
		randomBattleMoves: ["calmmind", "encore", "focusblast", "psychic", "psyshock", "shadowball"],
		tier: "OU",
		doublesTier: "DUU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		randomBattleMoves: ["bulkup", "bulletpunch", "dynamicpunch", "icepunch", "payback", "stoneedge", "substitute"],
		tier: "UU",
		doublesTier: "DUU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		randomBattleMoves: ["powerwhip", "sleeppowder", "sludgebomb", "suckerpunch", "sunnyday", "weatherball"],
		tier: "PU",
		doublesTier: "DUU",
	},
	tentacool: {
		tier: "PU",
		doublesTier: "LC",
	},
	tentacruel: {
		randomBattleMoves: ["gigadrain", "icebeam", "protect", "rapidspin", "scald", "toxic", "toxicspikes"],
		tier: "OU",
		doublesTier: "DUU",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		randomBattleMoves: ["earthquake", "explosion", "rockblast", "stealthrock", "suckerpunch", "toxic"],
		tier: "NU",
		doublesTier: "DUU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["drillrun", "flareblitz", "megahorn", "morningsun", "wildcharge", "willowisp"],
		tier: "PU",
		doublesTier: "DUU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		randomBattleMoves: ["calmmind", "icebeam", "psyshock", "scald", "slackoff", "thunderwave", "toxic"],
		tier: "UU",
		doublesTier: "DUU",
	},
	slowking: {
		randomBattleMoves: ["calmmind", "fireblast", "grassknot", "icebeam", "psychic", "slackoff", "surf", "trickroom"],
		tier: "RU",
		doublesTier: "DUU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "RU",
		doublesTier: "NFE",
	},
	magnezone: {
		randomBattleMoves: ["flashcannon", "hiddenpowerfire", "thunderbolt", "toxic", "voltswitch"],
		tier: "OU",
		doublesTier: "DUU",
	},
	farfetchd: {
		randomBattleMoves: ["bravebird", "leafblade", "quickattack", "return", "swordsdance"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		randomBattleMoves: ["bravebird", "pursuit", "quickattack", "return", "roost"],
		tier: "PU",
		doublesTier: "DUU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		randomBattleMoves: ["icebeam", "protect", "rest", "sleeptalk", "surf", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		randomBattleMoves: ["brickbreak", "curse", "firepunch", "gunkshot", "icepunch", "poisonjab", "rest", "shadowsneak"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["hydropump", "iceshard", "iciclespear", "rapidspin", "rockblast", "shellsmash", "spikes"],
		tier: "OU",
		doublesTier: "DOU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NU",
		doublesTier: "NFE",
	},
	gengar: {
		randomBattleMoves: ["focusblast", "shadowball", "sludgewave", "substitute", "trick", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		randomBattleMoves: ["curse", "earthquake", "gyroball", "roar", "stealthrock", "stoneedge", "toxic"],
		tier: "RU",
		doublesTier: "DUU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		randomBattleMoves: ["foulplay", "protect", "psychic", "thunderwave", "toxic", "wish"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["agility", "crabhammer", "return", "superpower", "swordsdance", "xscissor"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		randomBattleMoves: ["foulplay", "hiddenpowergrass", "hiddenpowerice", "taunt", "thunderbolt", "voltswitch"],
		tier: "NU",
		doublesTier: "DUU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leechseed", "protect", "psychic", "sleeppowder", "substitute"],
		tier: "NU",
		doublesTier: "DUU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		randomBattleMoves: ["bonemerang", "doubleedge", "earthquake", "firepunch", "stealthrock", "stoneedge"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		randomBattleMoves: ["closecombat", "earthquake", "fakeout", "stoneedge", "suckerpunch"],
		tier: "RU",
		doublesTier: "DUU",
	},
	hitmonchan: {
		randomBattleMoves: ["bulkup", "closecombat", "drainpunch", "icepunch", "machpunch", "rapidspin", "stoneedge"],
		tier: "RU",
		doublesTier: "DUU",
	},
	hitmontop: {
		randomBattleMoves: ["closecombat", "machpunch", "rapidspin", "stoneedge", "suckerpunch", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		randomBattleMoves: ["bodyslam", "earthquake", "healbell", "powerwhip", "protect", "swordsdance", "toxic", "wish"],
		tier: "NU",
		doublesTier: "DUU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["fireblast", "haze", "painsplit", "sludgebomb", "willowisp"],
		tier: "NU",
		doublesTier: "DUU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		randomBattleMoves: ["earthquake", "megahorn", "stealthrock", "stoneedge", "toxic"],
		tier: "RU",
		doublesTier: "NFE",
	},
	rhyperior: {
		randomBattleMoves: ["earthquake", "icepunch", "megahorn", "rockpolish", "stoneedge"],
		tier: "UU",
		doublesTier: "DUU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		randomBattleMoves: ["aromatherapy", "seismictoss", "softboiled", "stealthrock", "toxic"],
		tier: "UUBL",
		doublesTier: "NFE",
	},
	blissey: {
		randomBattleMoves: ["aromatherapy", "seismictoss", "softboiled", "stealthrock", "thunderwave", "toxic"],
		tier: "(OU)",
		doublesTier: "DUU",
	},
	tangela: {
		tier: "NU",
		doublesTier: "NFE",
	},
	tangrowth: {
		randomBattleMoves: ["earthquake", "hiddenpowerfire", "leechseed", "powerwhip", "rockslide", "sleeppowder", "synthesis"],
		tier: "RU",
		doublesTier: "DUU",
	},
	kangaskhan: {
		randomBattleMoves: ["doubleedge", "earthquake", "fakeout", "focuspunch", "return", "substitute", "suckerpunch"],
		tier: "NU",
		doublesTier: "DUU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		randomBattleMoves: ["dracometeor", "dragondance", "hiddenpowerelectric", "hydropump", "icebeam", "outrage", "raindance", "waterfall"],
		tier: "UU",
		doublesTier: "DOU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["drillrun", "icebeam", "megahorn", "return", "waterfall"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["hydropump", "icebeam", "psyshock", "rapidspin", "recover", "scald", "thunderbolt", "trick"],
		tier: "OU",
		doublesTier: "DUU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		randomBattleMoves: ["encore", "hiddenpowerfighting", "nastyplot", "psychic", "substitute", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	scyther: {
		randomBattleMoves: ["aerialace", "brickbreak", "bugbite", "quickattack", "roost", "swordsdance"],
		tier: "RU",
		doublesTier: "NFE",
	},
	scizor: {
		randomBattleMoves: ["bugbite", "bulletpunch", "pursuit", "roost", "superpower", "swordsdance", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		randomBattleMoves: ["focusblast", "icebeam", "lovelykiss", "nastyplot", "psyshock", "substitute", "trick"],
		tier: "NUBL",
		doublesTier: "DUU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NU",
		doublesTier: "NFE",
	},
	electivire: {
		randomBattleMoves: ["crosschop", "earthquake", "flamethrower", "icepunch", "voltswitch", "wildcharge"],
		tier: "RU",
		doublesTier: "DOU",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		randomBattleMoves: ["fireblast", "focusblast", "hiddenpowergrass", "substitute", "thunderbolt"],
		tier: "RU",
		doublesTier: "DUU",
	},
	pinsir: {
		randomBattleMoves: ["closecombat", "earthquake", "quickattack", "stealthrock", "stoneedge", "swordsdance", "xscissor"],
		tier: "NU",
		doublesTier: "DUU",
	},
	tauros: {
		randomBattleMoves: ["doubleedge", "earthquake", "pursuit", "retaliate", "stoneedge"],
		tier: "NU",
		doublesTier: "DUU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		randomBattleMoves: ["bounce", "dragondance", "earthquake", "icefang", "stoneedge", "substitute", "waterfall"],
		tier: "OU",
		doublesTier: "DOU",
	},
	lapras: {
		randomBattleMoves: ["healbell", "hydropump", "icebeam", "substitute", "thunderbolt", "toxic"],
		tier: "NU",
		doublesTier: "DUU",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		tier: "NU",
		doublesTier: "DUU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		randomBattleMoves: ["icebeam", "protect", "roar", "scald", "toxic", "wish"],
		tier: "(OU)",
		doublesTier: "DOU",
	},
	jolteon: {
		randomBattleMoves: ["hiddenpowerice", "signalbeam", "thunderbolt", "voltswitch"],
		tier: "(OU)",
		doublesTier: "DOU",
	},
	flareon: {
		randomBattleMoves: ["facade", "flamecharge", "rest", "sleeptalk"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	espeon: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "morningsun", "psychic", "psyshock", "signalbeam"],
		tier: "(OU)",
		doublesTier: "DOU",
	},
	umbreon: {
		randomBattleMoves: ["foulplay", "protect", "toxic", "wish"],
		tier: "UU",
		doublesTier: "DUU",
	},
	leafeon: {
		randomBattleMoves: ["leafblade", "return", "swordsdance", "xscissor"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	glaceon: {
		randomBattleMoves: ["hiddenpowerground", "icebeam", "protect", "shadowball", "toxic", "wish"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		randomBattleMoves: ["discharge", "icebeam", "recover", "toxic", "triattack"],
		tier: "UU",
		doublesTier: "NFE",
	},
	porygonz: {
		randomBattleMoves: ["agility", "darkpulse", "hiddenpowerfighting", "icebeam", "nastyplot", "thunderbolt", "triattack", "trick"],
		tier: "UU",
		doublesTier: "DUU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["hiddenpowergrass", "icebeam", "shellsmash", "spikes", "stealthrock", "surf"],
		tier: "RU",
		doublesTier: "DUU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["aquajet", "rapidspin", "stealthrock", "stoneedge", "superpower", "swordsdance", "waterfall"],
		tier: "RU",
		doublesTier: "DUU",
	},
	aerodactyl: {
		randomBattleMoves: ["aquatail", "doubleedge", "earthquake", "roost", "stealthrock", "stoneedge", "taunt"],
		tier: "RU",
		doublesTier: "DUU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		randomBattleMoves: ["bodyslam", "crunch", "curse", "earthquake", "firepunch", "pursuit", "rest"],
		tier: "UU",
		doublesTier: "DUU",
	},
	articuno: {
		randomBattleMoves: ["hurricane", "icebeam", "roost", "substitute", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	zapdos: {
		randomBattleMoves: ["heatwave", "hiddenpowerice", "roost", "substitute", "thunderbolt", "toxic", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	moltres: {
		randomBattleMoves: ["fireblast", "hiddenpowergrass", "hurricane", "roost", "substitute", "toxic", "uturn", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		randomBattleMoves: ["dragondance", "outrage", "rest", "sleeptalk", "waterfall"],
		tier: "NFE",
	},
	dragonite: {
		randomBattleMoves: ["dragondance", "earthquake", "extremespeed", "firepunch", "outrage", "roost"],
		tier: "OU",
		doublesTier: "DOU",
	},
	mewtwo: {
		randomBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "psystrike", "recover", "taunt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		randomBattleMoves: ["aurasphere", "fireblast", "nastyplot", "psychic", "softboiled", "stealthrock", "taunt", "uturn", "willowisp"],
		tier: "UU",
		doublesTier: "DUU",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		randomBattleMoves: ["aromatherapy", "dragontail", "gigadrain", "leechseed", "lightscreen", "reflect", "synthesis", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		randomBattleMoves: ["eruption", "fireblast", "focusblast", "hiddenpowergrass", "hiddenpowerrock"],
		tier: "RU",
		doublesTier: "DUU",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		randomBattleMoves: ["aquajet", "dragondance", "earthquake", "icepunch", "superpower", "swordsdance", "waterfall"],
		tier: "RU",
		doublesTier: "DUU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		randomBattleMoves: ["aquatail", "doubleedge", "firepunch", "shadowclaw", "trick", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		randomBattleMoves: ["airslash", "magiccoat", "nightshade", "roost", "toxic", "whirlwind"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		randomBattleMoves: ["encore", "lightscreen", "reflect", "roost", "toxic", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		randomBattleMoves: ["poisonjab", "suckerpunch", "toxicspikes", "xscissor"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		randomBattleMoves: ["healbell", "icebeam", "scald", "thunderbolt", "thunderwave", "voltswitch"],
		tier: "RU",
		doublesTier: "DUU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NFE",
	},
	togekiss: {
		randomBattleMoves: ["airslash", "aurasphere", "nastyplot", "roost", "thunderwave"],
		tier: "UU",
		doublesTier: "DOU",
	},
	natu: {
		tier: "PU",
		doublesTier: "LC",
	},
	xatu: {
		randomBattleMoves: ["heatwave", "psychic", "roost", "thunderwave", "toxic", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		randomBattleMoves: ["agility", "focusblast", "healbell", "hiddenpowergrass", "hiddenpowerice", "thunderbolt", "toxic", "voltswitch"],
		tier: "NU",
		doublesTier: "DUU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		randomBattleMoves: ["aquajet", "doubleedge", "icepunch", "superpower", "waterfall"],
		tier: "UU",
		doublesTier: "DUU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		randomBattleMoves: ["earthquake", "stealthrock", "stoneedge", "suckerpunch", "toxic", "woodhammer"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		randomBattleMoves: ["acrobatics", "encore", "energyball", "leechseed", "sleeppowder", "uturn"],
		tier: "PU",
		doublesTier: "DUU",
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		randomBattleMoves: ["fakeout", "lowkick", "pursuit", "return", "switcheroo", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		randomBattleMoves: ["earthpower", "encore", "gigadrain", "hiddenpowerrock", "solarbeam", "sunnyday"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	yanma: {
		tier: "NFE",
	},
	yanmega: {
		randomBattleMoves: ["airslash", "bugbuzz", "hiddenpowerground", "protect", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		randomBattleMoves: ["earthquake", "encore", "recover", "scald", "toxic"],
		tier: "RU",
		doublesTier: "DUU",
	},
	murkrow: {
		randomBattleMoves: ["foulplay", "roost", "taunt", "thunderwave", "toxic"],
		tier: "PU",
		doublesTier: "NFE",
	},
	honchkrow: {
		randomBattleMoves: ["bravebird", "heatwave", "pursuit", "roost", "substitute", "suckerpunch", "superpower"],
		tier: "UU",
		doublesTier: "DUU",
	},
	misdreavus: {
		tier: "NU",
		doublesTier: "NFE",
	},
	mismagius: {
		randomBattleMoves: ["hiddenpowerfighting", "nastyplot", "shadowball", "substitute", "taunt", "thunderbolt", "willowisp"],
		tier: "UU",
		doublesTier: "DUU",
	},
	unown: {
		randomBattleMoves: ["hiddenpowerpsychic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		randomBattleMoves: ["counter", "destinybond", "encore", "mirrorcoat"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	girafarig: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "hypervoice", "psychic", "psyshock", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		randomBattleMoves: ["gyroball", "rapidspin", "spikes", "stealthrock", "toxic", "voltswitch"],
		tier: "OU",
		doublesTier: "DUU",
	},
	dunsparce: {
		randomBattleMoves: ["bite", "bodyslam", "coil", "glare", "headbutt", "rockslide", "roost"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	gligar: {
		randomBattleMoves: ["earthquake", "roost", "stealthrock", "taunt", "toxic", "uturn"],
		tier: "UU",
		doublesTier: "NFE",
	},
	gliscor: {
		randomBattleMoves: ["earthquake", "icefang", "protect", "roost", "substitute", "swordsdance", "taunt", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		randomBattleMoves: ["closecombat", "crunch", "healbell", "return", "thunderwave", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	qwilfish: {
		randomBattleMoves: ["destinybond", "poisonjab", "spikes", "taunt", "thunderwave", "toxicspikes", "waterfall"],
		tier: "RU",
		doublesTier: "DUU",
	},
	shuckle: {
		randomBattleMoves: ["encore", "protect", "stealthrock", "toxic", "wrap"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	heracross: {
		randomBattleMoves: ["closecombat", "earthquake", "facade", "megahorn", "stoneedge"],
		tier: "UU",
		doublesTier: "DUU",
	},
	sneasel: {
		tier: "PU",
		doublesTier: "NFE",
	},
	weavile: {
		randomBattleMoves: ["icepunch", "iceshard", "lowkick", "nightslash", "pursuit", "swordsdance"],
		tier: "UU",
		doublesTier: "DOU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		randomBattleMoves: ["closecombat", "crunch", "earthquake", "facade", "protect", "swordsdance"],
		tier: "PU",
		doublesTier: "DUU",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		randomBattleMoves: ["hiddenpowerrock", "lavaplume", "recover", "stealthrock", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NU",
		doublesTier: "NFE",
	},
	mamoswine: {
		randomBattleMoves: ["earthquake", "iceshard", "iciclecrash", "stealthrock", "superpower"],
		tier: "OU",
		doublesTier: "DOU",
	},
	corsola: {
		randomBattleMoves: ["powergem", "recover", "scald", "stealthrock", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		randomBattleMoves: ["energyball", "fireblast", "hydropump", "icebeam", "thunderwave"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	delibird: {
		randomBattleMoves: ["aerialace", "icebeam", "iceshard", "rapidspin"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		randomBattleMoves: ["airslash", "hydropump", "icebeam", "raindance", "rest", "scald", "sleeptalk"],
		tier: "PU",
		doublesTier: "DUU",
	},
	skarmory: {
		randomBattleMoves: ["bravebird", "roost", "spikes", "stealthrock", "whirlwind"],
		tier: "OU",
		doublesTier: "DUU",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		randomBattleMoves: ["darkpulse", "fireblast", "hiddenpowergrass", "nastyplot", "suckerpunch"],
		tier: "UU",
		doublesTier: "DUU",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		randomBattleMoves: ["earthquake", "headsmash", "iceshard", "rapidspin", "seedbomb", "stealthrock"],
		tier: "(OU)",
		doublesTier: "DUU",
	},
	stantler: {
		randomBattleMoves: ["doubleedge", "earthquake", "jumpkick", "megahorn", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	smeargle: {
		randomBattleMoves: ["memento", "spikes", "spore", "stealthrock", "whirlwind"],
		tier: "RU",
		doublesTier: "DUU",
	},
	miltank: {
		randomBattleMoves: ["bodyslam", "earthquake", "healbell", "milkdrink", "stealthrock", "toxic"],
		tier: "NU",
		doublesTier: "DUU",
	},
	raikou: {
		randomBattleMoves: ["aurasphere", "calmmind", "hiddenpowerice", "substitute", "thunderbolt", "voltswitch"],
		tier: "UU",
		doublesTier: "DUU",
	},
	entei: {
		randomBattleMoves: ["bulldoze", "extremespeed", "flareblitz", "hiddenpowergrass", "stoneedge"],
		tier: "RU",
		doublesTier: "DUU",
	},
	suicune: {
		randomBattleMoves: ["calmmind", "hiddenpowerelectric", "hydropump", "icebeam", "rest", "roar", "scald", "sleeptalk"],
		tier: "UU",
		doublesTier: "DUU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		randomBattleMoves: ["crunch", "fireblast", "pursuit", "stealthrock", "stoneedge", "superpower"],
		tier: "OU",
		doublesTier: "DOU",
	},
	lugia: {
		randomBattleMoves: ["aeroblast", "earthquake", "roost", "substitute", "toxic", "whirlwind"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	hooh: {
		randomBattleMoves: ["bravebird", "earthquake", "roost", "sacredfire", "substitute", "toxic"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	celebi: {
		randomBattleMoves: ["earthpower", "gigadrain", "hiddenpowerice", "leafstorm", "nastyplot", "psychic", "recover", "stealthrock", "uturn"],
		tier: "OU",
		doublesTier: "DUU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		randomBattleMoves: ["acrobatics", "earthquake", "gigadrain", "hiddenpowerfire", "leafblade", "leechseed", "substitute", "swordsdance"],
		tier: "RU",
		doublesTier: "DUU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "PUBL",
		doublesTier: "DUU",
	},
	blaziken: {
		randomBattleMoves: ["flareblitz", "highjumpkick", "protect", "stoneedge", "swordsdance"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		randomBattleMoves: ["earthquake", "icebeam", "protect", "roar", "scald", "stealthrock", "toxic"],
		tier: "UU",
		doublesTier: "DUU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		randomBattleMoves: ["crunch", "facade", "firefang", "howl", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		randomBattleMoves: ["bellydrum", "extremespeed", "seedbomb", "shadowclaw"],
		tier: "PUBL",
		doublesTier: "DUU",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		randomBattleMoves: ["bugbuzz", "hiddenpowerground", "psychic", "quiverdance"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		randomBattleMoves: ["bugbuzz", "quiverdance", "roost", "sludgebomb"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		randomBattleMoves: ["gigadrain", "hydropump", "icebeam", "raindance", "scald"],
		tier: "NU",
		doublesTier: "DOU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		randomBattleMoves: ["darkpulse", "hiddenpowerfire", "leafstorm", "naturepower", "seedbomb", "suckerpunch", "swordsdance"],
		tier: "PU",
		doublesTier: "DUU",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		randomBattleMoves: ["bravebird", "facade", "protect", "quickattack", "uturn"],
		tier: "NU",
		doublesTier: "DUU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		randomBattleMoves: ["hurricane", "icebeam", "roost", "scald", "tailwind", "toxic", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		randomBattleMoves: ["calmmind", "focusblast", "painsplit", "psychic", "substitute", "thunderbolt", "trick", "willowisp"],
		tier: "NU",
		doublesTier: "DUU",
	},
	gallade: {
		randomBattleMoves: ["closecombat", "drainpunch", "nightslash", "substitute", "swordsdance", "trick", "zenheadbutt"],
		tier: "RU",
		doublesTier: "DUU",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		randomBattleMoves: ["airslash", "bugbuzz", "hydropump", "quiverdance", "roost"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		randomBattleMoves: ["bulletseed", "machpunch", "spore", "stoneedge", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		randomBattleMoves: ["bulkup", "earthquake", "return", "slackoff", "taunt", "toxic"],
		tier: "PUBL",
		doublesTier: "NFE",
	},
	slaking: {
		randomBattleMoves: ["earthquake", "nightslash", "pursuit", "retaliate", "return"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		randomBattleMoves: ["aerialace", "substitute", "swordsdance", "xscissor"],
		tier: "NU",
		doublesTier: "DUU",
	},
	shedinja: {
		randomBattleMoves: ["shadowclaw", "shadowsneak", "swordsdance", "willowisp", "xscissor"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		randomBattleMoves: ["fireblast", "focusblast", "hypervoice", "lowkick", "surf"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		randomBattleMoves: ["bulletpunch", "closecombat", "facade", "fakeout", "stoneedge"],
		tier: "RU",
		doublesTier: "DUU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		randomBattleMoves: ["earthpower", "powergem", "stealthrock", "toxic", "voltswitch"],
		tier: "NU",
		doublesTier: "DUU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		randomBattleMoves: ["doubleedge", "fakeout", "icebeam", "suckerpunch", "thunderwave"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	sableye: {
		randomBattleMoves: ["foulplay", "nightshade", "recover", "taunt", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	mawile: {
		randomBattleMoves: ["firefang", "ironhead", "stealthrock", "suckerpunch", "swordsdance"],
		tier: "PU",
		doublesTier: "DUU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		randomBattleMoves: ["aquatail", "earthquake", "headsmash", "heavyslam", "rockpolish", "stealthrock", "thunderwave"],
		tier: "RU",
		doublesTier: "DUU",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		randomBattleMoves: ["bulletpunch", "highjumpkick", "icepunch", "thunderpunch", "trick", "zenheadbutt"],
		tier: "RU",
		doublesTier: "DUU",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		randomBattleMoves: ["flamethrower", "hiddenpowerice", "overheat", "switcheroo", "thunderbolt", "voltswitch"],
		tier: "RU",
		doublesTier: "DUU",
	},
	plusle: {
		randomBattleMoves: ["grassknot", "hiddenpowerice", "nastyplot", "thunderbolt", "voltswitch"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	minun: {
		randomBattleMoves: ["encore", "hiddenpowerice", "nastyplot", "substitute", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	volbeat: {
		randomBattleMoves: ["bugbuzz", "encore", "roost", "thunderwave", "uturn"],
		tier: "PU",
		doublesTier: "DUU",
	},
	illumise: {
		randomBattleMoves: ["bugbuzz", "encore", "roost", "substitute", "thunderwave", "wish"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "NU",
		doublesTier: "NFE",
	},
	roserade: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leafstorm", "sleeppowder", "sludgebomb", "spikes", "synthesis", "toxicspikes"],
		tier: "UU",
		doublesTier: "DUU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		randomBattleMoves: ["earthquake", "encore", "painsplit", "protect", "sludgebomb", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		randomBattleMoves: ["crunch", "earthquake", "icebeam", "protect", "waterfall", "zenheadbutt"],
		tier: "UU",
		doublesTier: "DUU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "surf", "waterspout"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		randomBattleMoves: ["earthquake", "hiddenpowergrass", "lavaplume", "roar", "stealthrock"],
		tier: "NU",
		doublesTier: "DUU",
	},
	torkoal: {
		randomBattleMoves: ["earthquake", "lavaplume", "protect", "rapidspin", "stealthrock", "toxic", "yawn"],
		tier: "NU",
		doublesTier: "DUU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		randomBattleMoves: ["focusblast", "healbell", "psychic", "shadowball", "thunderwave", "trick", "whirlwind"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	spinda: {
		randomBattleMoves: ["return", "suckerpunch", "superpower", "trickroom"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		randomBattleMoves: ["earthquake", "firepunch", "outrage", "roost", "stoneedge", "superpower", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		randomBattleMoves: ["drainpunch", "seedbomb", "spikes", "substitute", "suckerpunch", "swordsdance"],
		tier: "NU",
		doublesTier: "DUU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		randomBattleMoves: ["dracometeor", "dragondance", "earthquake", "fireblast", "healbell", "outrage", "roost"],
		tier: "NU",
		doublesTier: "DUU",
	},
	zangoose: {
		randomBattleMoves: ["closecombat", "facade", "nightslash", "quickattack", "swordsdance"],
		tier: "NU",
		doublesTier: "DUU",
	},
	seviper: {
		randomBattleMoves: ["earthquake", "flamethrower", "gigadrain", "sludgebomb", "suckerpunch", "switcheroo"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	lunatone: {
		randomBattleMoves: ["earthpower", "hiddenpowerrock", "moonlight", "psychic", "stealthrock", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	solrock: {
		randomBattleMoves: ["explosion", "lightscreen", "morningsun", "reflect", "rockslide", "stealthrock", "willowisp"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		randomBattleMoves: ["dragondance", "earthquake", "icebeam", "waterfall"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		randomBattleMoves: ["crunch", "dragondance", "superpower", "waterfall"],
		tier: "RU",
		doublesTier: "DUU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		randomBattleMoves: ["earthquake", "icebeam", "psychic", "rapidspin", "stealthrock", "toxic"],
		tier: "UU",
		doublesTier: "DUU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		randomBattleMoves: ["earthquake", "recover", "rockslide", "seedbomb", "stealthrock", "swordsdance", "toxic"],
		tier: "NU",
		doublesTier: "DUU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		randomBattleMoves: ["aquatail", "earthquake", "rapidspin", "stealthrock", "stoneedge", "swordsdance", "xscissor"],
		tier: "NU",
		doublesTier: "DUU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		randomBattleMoves: ["dragontail", "haze", "icebeam", "recover", "scald", "toxic"],
		tier: "UU",
		doublesTier: "DUU",
	},
	castform: {
		tier: "(PU)",
		doublesTier: "DUU",
	},
	castformsunny: {
		randomBattleMoves: ["icebeam", "solarbeam", "sunnyday", "weatherball"],
	},
	castformrainy: {
		randomBattleMoves: ["icebeam", "raindance", "thunder", "weatherball"],
	},
	castformsnowy: {},
	kecleon: {
		randomBattleMoves: ["foulplay", "recover", "stealthrock", "thunderwave", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		randomBattleMoves: ["pursuit", "shadowclaw", "shadowsneak", "trick", "willowisp"],
		tier: "PU",
		doublesTier: "DUU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		randomBattleMoves: ["nightshade", "rest", "sleeptalk", "willowisp"],
		tier: "UU",
		doublesTier: "NFE",
	},
	dusknoir: {
		randomBattleMoves: ["earthquake", "icepunch", "painsplit", "shadowsneak", "trick", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	tropius: {
		randomBattleMoves: ["airslash", "leechseed", "protect", "substitute", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		randomBattleMoves: ["calmmind", "healingwish", "psychic", "recover", "shadowball", "toxic", "yawn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	absol: {
		randomBattleMoves: ["fireblast", "nightslash", "psychocut", "pursuit", "suckerpunch", "superpower", "swordsdance"],
		tier: "RU",
		doublesTier: "DUU",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		randomBattleMoves: ["earthquake", "explosion", "icebeam", "spikes", "taunt"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	froslass: {
		randomBattleMoves: ["destinybond", "icebeam", "shadowball", "spikes", "taunt", "thunderwave"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		randomBattleMoves: ["encore", "icebeam", "protect", "roar", "surf", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		randomBattleMoves: ["icebeam", "return", "shellsmash", "waterfall"],
		tier: "PU",
		doublesTier: "DUU",
	},
	gorebyss: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "shellsmash"],
		tier: "NU",
		doublesTier: "DUU",
	},
	relicanth: {
		randomBattleMoves: ["doubleedge", "earthquake", "headsmash", "stealthrock", "waterfall"],
		tier: "PU",
		doublesTier: "DUU",
	},
	luvdisc: {
		randomBattleMoves: ["icebeam", "protect", "surf", "sweetkiss", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		randomBattleMoves: ["aquatail", "brickbreak", "dracometeor", "dragondance", "earthquake", "fireblast", "outrage", "roost"],
		tier: "OU",
		doublesTier: "DOU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NU",
		doublesTier: "NFE",
	},
	metagross: {
		randomBattleMoves: ["agility", "bulletpunch", "earthquake", "meteormash", "pursuit", "stealthrock", "zenheadbutt"],
		tier: "(OU)",
		doublesTier: "DOU",
	},
	regirock: {
		randomBattleMoves: ["drainpunch", "protect", "rockslide", "stealthrock", "thunderwave", "toxic"],
		tier: "NU",
		doublesTier: "DUU",
	},
	regice: {
		randomBattleMoves: ["focusblast", "icebeam", "rest", "rockpolish", "sleeptalk", "thunderbolt"],
		tier: "NU",
		doublesTier: "DUU",
	},
	registeel: {
		randomBattleMoves: ["curse", "ironhead", "protect", "rest", "sleeptalk", "stealthrock", "toxic"],
		tier: "UU",
		doublesTier: "DUU",
	},
	latias: {
		randomBattleMoves: ["calmmind", "dracometeor", "healingwish", "hiddenpowerfire", "psyshock", "roost", "surf"],
		tier: "OU",
		doublesTier: "DUU",
	},
	latios: {
		randomBattleMoves: ["dracometeor", "hiddenpowerfire", "psyshock", "roost", "surf", "trick"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kyogre: {
		randomBattleMoves: ["calmmind", "icebeam", "rest", "sleeptalk", "surf", "thunder", "waterspout"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	groudon: {
		randomBattleMoves: ["earthquake", "firepunch", "stealthrock", "stoneedge", "swordsdance", "thunderwave"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	rayquaza: {
		randomBattleMoves: ["dracometeor", "dragondance", "earthquake", "extremespeed", "outrage", "swordsdance", "vcreate"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	jirachi: {
		randomBattleMoves: ["bodyslam", "firepunch", "icepunch", "ironhead", "substitute", "uturn", "wish"],
		tier: "OU",
		doublesTier: "DUber",
	},
	deoxys: {
		randomBattleMoves: ["extremespeed", "hiddenpowerfire", "icebeam", "psychoboost", "stealthrock", "superpower"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	deoxysattack: {
		randomBattleMoves: ["extremespeed", "hiddenpowerfire", "icebeam", "psychoboost", "stealthrock", "superpower"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	deoxysdefense: {
		randomBattleMoves: ["magiccoat", "recover", "seismictoss", "spikes", "taunt", "toxic"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	deoxysspeed: {
		randomBattleMoves: ["icebeam", "lightscreen", "psychoboost", "reflect", "spikes", "stealthrock", "superpower", "taunt"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		randomBattleMoves: ["earthquake", "rockpolish", "stealthrock", "stoneedge", "synthesis", "woodhammer"],
		tier: "PU",
		doublesTier: "DUU",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "PU",
		doublesTier: "NFE",
	},
	infernape: {
		randomBattleMoves: ["closecombat", "flareblitz", "hiddenpowerice", "machpunch", "overheat", "swordsdance", "thunderpunch", "uturn"],
		tier: "(OU)",
		doublesTier: "DOU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		randomBattleMoves: ["agility", "grassknot", "hydropump", "icebeam", "protect", "scald", "stealthrock", "toxic"],
		tier: "UU",
		doublesTier: "DUU",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		randomBattleMoves: ["bravebird", "closecombat", "doubleedge", "quickattack", "roost", "uturn"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		randomBattleMoves: ["curse", "quickattack", "rest", "waterfall"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		randomBattleMoves: ["brickbreak", "bugbite", "nightslash", "return", "swordsdance"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		randomBattleMoves: ["crunch", "facade", "icefang", "superpower", "voltswitch", "wildcharge"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		randomBattleMoves: ["crunch", "earthquake", "firepunch", "headsmash", "rockpolish", "superpower"],
		tier: "PU",
		doublesTier: "DUU",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		randomBattleMoves: ["metalburst", "protect", "roar", "rockblast", "stealthrock", "toxic"],
		tier: "NU",
		doublesTier: "DUU",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		randomBattleMoves: ["gigadrain", "hiddenpowerrock", "leafstorm", "protect", "signalbeam", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	wormadamsandy: {
		randomBattleMoves: ["earthquake", "protect", "rockblast", "stealthrock", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	wormadamtrash: {
		randomBattleMoves: ["ironhead", "protect", "stealthrock", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	mothim: {
		randomBattleMoves: ["airslash", "bugbuzz", "hiddenpowerground", "quiverdance", "substitute"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		randomBattleMoves: ["attackorder", "protect", "roost", "substitute", "toxic"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	pachirisu: {
		randomBattleMoves: ["protect", "superfang", "thunderwave", "toxic", "voltswitch"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		randomBattleMoves: ["aquajet", "bulkup", "crunch", "icepunch", "switcheroo", "taunt", "waterfall"],
		tier: "NU",
		doublesTier: "DUU",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		randomBattleMoves: ["energyball", "healingwish", "hiddenpowerrock", "hiddenpowerfire", "naturepower"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	cherrimsunshine: {
		randomBattleMoves: ["naturepower", "solarbeam", "sunnyday", "weatherball"],
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		randomBattleMoves: ["earthquake", "icebeam", "recover", "scald", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	drifloon: {
		tier: "LC",
	},
	drifblim: {
		randomBattleMoves: ["acrobatics", "destinybond", "disable", "shadowball", "substitute", "willowisp"],
		tier: "NU",
		doublesTier: "DUU",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		randomBattleMoves: ["firepunch", "healingwish", "icepunch", "jumpkick", "return", "switcheroo", "thunderpunch"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		randomBattleMoves: ["fakeout", "hypnosis", "return", "suckerpunch", "uturn"],
		tier: "PU",
		doublesTier: "DUU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		randomBattleMoves: ["crunch", "fireblast", "poisonjab", "pursuit", "suckerpunch", "taunt"],
		tier: "NU",
		doublesTier: "DUU",
	},
	bronzor: {
		tier: "PU",
		doublesTier: "LC",
	},
	bronzong: {
		randomBattleMoves: ["earthquake", "hypnosis", "psychic", "stealthrock", "toxic"],
		tier: "UU",
		doublesTier: "DOU",
	},
	chatot: {
		randomBattleMoves: ["chatter", "heatwave", "hiddenpowerground", "hypervoice", "nastyplot", "substitute", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	spiritomb: {
		randomBattleMoves: ["calmmind", "darkpulse", "foulplay", "rest", "shadowsneak", "sleeptalk", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "PU",
		doublesTier: "NFE",
	},
	garchomp: {
		randomBattleMoves: ["aquatail", "earthquake", "fireblast", "outrage", "stealthrock", "stoneedge", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	riolu: {
		tier: "PUBL",
		doublesTier: "LC",
	},
	lucario: {
		randomBattleMoves: ["closecombat", "crunch", "extremespeed", "icepunch", "swordsdance"],
		tier: "(OU)",
		doublesTier: "DOU",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		randomBattleMoves: ["earthquake", "slackoff", "stealthrock", "stoneedge", "toxic", "whirlwind"],
		tier: "(OU)",
		doublesTier: "DUU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		randomBattleMoves: ["aquatail", "crunch", "earthquake", "poisonjab", "pursuit", "swordsdance", "taunt", "toxicspikes"],
		tier: "RU",
		doublesTier: "DUU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		randomBattleMoves: ["drainpunch", "icepunch", "poisonjab", "substitute", "suckerpunch", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	carnivine: {
		randomBattleMoves: ["leechseed", "powerwhip", "return", "sleeppowder", "substitute", "swordsdance"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		randomBattleMoves: ["icebeam", "protect", "scald", "toxic", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		randomBattleMoves: ["blizzard", "earthquake", "hiddenpowerfire", "iceshard", "leechseed", "woodhammer"],
		tier: "UU",
		doublesTier: "DOU",
	},
	rotom: {
		randomBattleMoves: ["hiddenpowerice", "painsplit", "shadowball", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	rotomheat: {
		randomBattleMoves: ["hiddenpowergrass", "overheat", "painsplit", "thunderbolt", "thunderwave", "trick", "voltswitch", "willowisp"],
		tier: "UU",
		doublesTier: "DUU",
	},
	rotomwash: {
		randomBattleMoves: ["hiddenpowerice", "hydropump", "painsplit", "thunderbolt", "thunderwave", "trick", "voltswitch", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	rotomfrost: {
		randomBattleMoves: ["blizzard", "hiddenpowerfire", "painsplit", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "PUBL",
		doublesTier: "DUU",
	},
	rotomfan: {
		randomBattleMoves: ["airslash", "painsplit", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "NU",
		doublesTier: "DUU",
	},
	rotommow: {
		randomBattleMoves: ["hiddenpowerfire", "leafstorm", "painsplit", "thunderbolt", "thunderwave", "trick", "voltswitch", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	uxie: {
		randomBattleMoves: ["healbell", "lightscreen", "memento", "psychic", "reflect", "stealthrock", "thunderwave", "uturn", "yawn"],
		tier: "RU",
		doublesTier: "DUU",
	},
	mesprit: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "icebeam", "psychic", "stealthrock", "thunderbolt", "trick", "uturn"],
		tier: "RU",
		doublesTier: "DUU",
	},
	azelf: {
		randomBattleMoves: ["energyball", "fireblast", "nastyplot", "psychic", "stealthrock", "taunt", "trick", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	dialga: {
		randomBattleMoves: ["aurasphere", "dracometeor", "dragontail", "fireblast", "stealthrock", "thunderbolt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	palkia: {
		randomBattleMoves: ["dracometeor", "dragontail", "fireblast", "hydropump", "spacialrend", "surf", "thunderbolt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	heatran: {
		randomBattleMoves: ["earthpower", "fireblast", "flashcannon", "hiddenpowerice", "lavaplume", "protect", "roar", "stealthrock", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	regigigas: {
		randomBattleMoves: ["confuseray", "return", "rockslide", "substitute", "thunderwave"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	giratina: {
		randomBattleMoves: ["calmmind", "dragonpulse", "dragontail", "rest", "sleeptalk", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	giratinaorigin: {
		randomBattleMoves: ["dracometeor", "earthquake", "hiddenpowerfire", "shadowsneak", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	cresselia: {
		randomBattleMoves: ["calmmind", "hiddenpowerfighting", "moonlight", "psychic", "thunderwave", "toxic"],
		tier: "RUBL",
		doublesTier: "DOU",
	},
	phione: {
		randomBattleMoves: ["healbell", "icebeam", "scald", "toxic", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	manaphy: {
		randomBattleMoves: ["energyball", "icebeam", "surf", "tailglow"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	darkrai: {
		randomBattleMoves: ["darkpulse", "darkvoid", "focusblast", "nastyplot", "substitute"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	shaymin: {
		randomBattleMoves: ["earthpower", "hiddenpowerfire", "leechseed", "psychic", "rest", "seedflare"],
		tier: "UU",
		doublesTier: "DUU",
	},
	shayminsky: {
		randomBattleMoves: ["airslash", "earthpower", "hiddenpowerfire", "hiddenpowerice", "leechseed", "seedflare", "substitute"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceus: {
		randomBattleMoves: ["earthquake", "extremespeed", "recover", "shadowclaw", "swordsdance"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	arceusbug: {
		randomBattleMoves: ["earthquake", "recover", "stoneedge", "swordsdance", "xscissor"],
	},
	arceusdark: {
		randomBattleMoves: ["calmmind", "judgment", "recover", "refresh"],
	},
	arceusdragon: {
		randomBattleMoves: ["earthquake", "extremespeed", "outrage", "recover", "swordsdance"],
	},
	arceuselectric: {
		randomBattleMoves: ["calmmind", "icebeam", "judgment", "recover"],
	},
	arceusfighting: {
		randomBattleMoves: ["calmmind", "darkpulse", "icebeam", "judgment", "recover"],
	},
	arceusfire: {
		randomBattleMoves: ["calmmind", "fireblast", "judgment", "recover", "thunderbolt"],
	},
	arceusflying: {
		randomBattleMoves: ["calmmind", "earthpower", "judgment", "recover", "substitute"],
	},
	arceusghost: {
		randomBattleMoves: ["calmmind", "focusblast", "judgment", "recover", "roar", "willowisp"],
	},
	arceusgrass: {
		randomBattleMoves: ["calmmind", "earthpower", "icebeam", "judgment", "recover", "thunderwave"],
	},
	arceusground: {
		randomBattleMoves: ["calmmind", "icebeam", "judgment", "recover", "willowisp"],
	},
	arceusice: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "recover", "thunderbolt"],
	},
	arceuspoison: {
		randomBattleMoves: ["flamethrower", "icebeam", "recover", "sludgebomb", "stealthrock", "willowisp"],
	},
	arceuspsychic: {
		randomBattleMoves: ["calmmind", "darkpulse", "focusblast", "judgment", "recover"],
	},
	arceusrock: {
		randomBattleMoves: ["earthquake", "recover", "stoneedge", "swordsdance"],
	},
	arceussteel: {
		randomBattleMoves: ["calmmind", "judgment", "recover", "thunderbolt", "willowisp"],
	},
	arceuswater: {
		randomBattleMoves: ["brickbreak", "extremespeed", "recover", "swordsdance", "waterfall"],
	},
	victini: {
		randomBattleMoves: ["blueflare", "boltstrike", "energyball", "focusblast", "glaciate", "trick", "uturn", "vcreate"],
		tier: "UU",
		doublesTier: "DOU",
	},
	snivy: {
		tier: "LC",
	},
	servine: {
		tier: "NFE",
	},
	serperior: {
		randomBattleMoves: ["calmmind", "dragonpulse", "gigadrain", "hiddenpowerfire", "leechseed", "substitute"],
		tier: "NU",
		doublesTier: "DUU",
	},
	tepig: {
		tier: "LC",
	},
	pignite: {
		tier: "NFE",
	},
	emboar: {
		randomBattleMoves: ["earthquake", "fireblast", "flareblitz", "grassknot", "headsmash", "superpower", "wildcharge"],
		tier: "RU",
		doublesTier: "DUU",
	},
	oshawott: {
		tier: "LC",
	},
	dewott: {
		tier: "NFE",
	},
	samurott: {
		randomBattleMoves: ["aquajet", "grassknot", "icebeam", "megahorn", "superpower", "swordsdance", "waterfall"],
		tier: "NU",
		doublesTier: "DUU",
	},
	patrat: {
		tier: "LC",
	},
	watchog: {
		randomBattleMoves: ["crunch", "hypnosis", "return", "substitute", "superfang", "swordsdance"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	lillipup: {
		tier: "LC",
	},
	herdier: {
		tier: "NFE",
	},
	stoutland: {
		randomBattleMoves: ["crunch", "return", "superpower", "thunderwave", "wildcharge"],
		tier: "PU",
		doublesTier: "DUU",
	},
	purrloin: {
		tier: "LC",
	},
	liepard: {
		randomBattleMoves: ["darkpulse", "encore", "hiddenpowerfire", "nastyplot", "thunderwave"],
		tier: "NU",
		doublesTier: "DUU",
	},
	pansage: {
		tier: "LC",
	},
	simisage: {
		randomBattleMoves: ["focusblast", "gigadrain", "hiddenpowerrock", "leechseed", "nastyplot", "substitute"],
		tier: "PU",
		doublesTier: "DUU",
	},
	pansear: {
		tier: "LC",
	},
	simisear: {
		randomBattleMoves: ["fireblast", "focusblast", "grassknot", "hiddenpowerrock", "nastyplot", "substitute"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	panpour: {
		tier: "LC",
	},
	simipour: {
		randomBattleMoves: ["focusblast", "hiddenpowergrass", "hydropump", "icebeam", "nastyplot", "substitute"],
		tier: "PUBL",
		doublesTier: "DUU",
	},
	munna: {
		tier: "LC",
	},
	musharna: {
		randomBattleMoves: ["calmmind", "healbell", "hiddenpowerground", "moonlight", "psychic", "signalbeam", "toxic", "trickroom"],
		tier: "NU",
		doublesTier: "DUU",
	},
	pidove: {
		tier: "LC",
	},
	tranquill: {
		tier: "NFE",
	},
	unfezant: {
		randomBattleMoves: ["hypnosis", "pluck", "return", "roost", "tailwind", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	blitzle: {
		tier: "LC",
	},
	zebstrika: {
		randomBattleMoves: ["hiddenpowergrass", "overheat", "thunderbolt", "voltswitch", "wildcharge"],
		tier: "PU",
		doublesTier: "DUU",
	},
	roggenrola: {
		tier: "LC",
	},
	boldore: {
		tier: "NFE",
	},
	gigalith: {
		randomBattleMoves: ["earthquake", "explosion", "rockblast", "stealthrock", "stoneedge", "superpower"],
		tier: "NU",
		doublesTier: "DUU",
	},
	woobat: {
		tier: "LC",
	},
	swoobat: {
		randomBattleMoves: ["airslash", "calmmind", "heatwave", "roost", "storedpower"],
		tier: "PU",
		doublesTier: "DUU",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		randomBattleMoves: ["earthquake", "ironhead", "rapidspin", "rockslide", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	audino: {
		randomBattleMoves: ["doubleedge", "healbell", "magiccoat", "protect", "toxic", "wish"],
		tier: "PU",
		doublesTier: "DUU",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		tier: "NU",
		doublesTier: "NFE",
	},
	conkeldurr: {
		randomBattleMoves: ["bulkup", "drainpunch", "icepunch", "machpunch", "thunderpunch"],
		tier: "OU",
		doublesTier: "DOU",
	},
	tympole: {
		tier: "LC",
	},
	palpitoad: {
		tier: "NFE",
	},
	seismitoad: {
		randomBattleMoves: ["earthquake", "hydropump", "raindance", "sludgebomb", "stealthrock", "toxic"],
		tier: "NU",
		doublesTier: "DUU",
	},
	throh: {
		randomBattleMoves: ["bulkup", "icepunch", "payback", "rest", "sleeptalk", "stormthrow"],
		tier: "PUBL",
		doublesTier: "DUU",
	},
	sawk: {
		randomBattleMoves: ["bulkup", "closecombat", "earthquake", "icepunch", "stoneedge"],
		tier: "NU",
		doublesTier: "DUU",
	},
	sewaddle: {
		tier: "LC",
	},
	swadloon: {
		tier: "NFE",
	},
	leavanny: {
		randomBattleMoves: ["leafblade", "swordsdance", "synthesis", "xscissor"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	venipede: {
		tier: "LC",
	},
	whirlipede: {
		tier: "NFE",
	},
	scolipede: {
		randomBattleMoves: ["aquatail", "earthquake", "megahorn", "rockslide", "spikes", "swordsdance"],
		tier: "NUBL",
		doublesTier: "DUU",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		randomBattleMoves: ["encore", "gigadrain", "leechseed", "stunspore", "taunt", "uturn"],
		tier: "RU",
		doublesTier: "DOU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "hiddenpowerrock", "petaldance", "quiverdance", "sleeppowder"],
		tier: "RU",
		doublesTier: "DUU",
	},
	basculin: {
		randomBattleMoves: ["aquajet", "crunch", "superpower", "waterfall", "zenheadbutt"],
		tier: "NU",
		doublesTier: "DUU",
	},
	basculinbluestriped: {
		randomBattleMoves: ["aquajet", "crunch", "superpower", "waterfall", "zenheadbutt"],
		tier: "NU",
		doublesTier: "DUU",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "PU",
		doublesTier: "NFE",
	},
	krookodile: {
		randomBattleMoves: ["crunch", "earthquake", "pursuit", "stealthrock", "stoneedge", "superpower"],
		tier: "UU",
		doublesTier: "DUU",
	},
	darumaka: {
		tier: "LC",
	},
	darmanitan: {
		randomBattleMoves: ["earthquake", "flareblitz", "rockslide", "superpower", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	maractus: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leechseed", "spikes", "toxic"],
		tier: "PU",
		doublesTier: "DUU",
	},
	dwebble: {
		tier: "PU",
		doublesTier: "LC",
	},
	crustle: {
		randomBattleMoves: ["earthquake", "rockblast", "shellsmash", "spikes", "stealthrock", "stoneedge", "xscissor"],
		tier: "RU",
		doublesTier: "DUU",
	},
	scraggy: {
		tier: "PU",
		doublesTier: "NFE",
	},
	scrafty: {
		randomBattleMoves: ["crunch", "dragondance", "highjumpkick", "icepunch", "zenheadbutt"],
		tier: "UU",
		doublesTier: "DUU",
	},
	sigilyph: {
		randomBattleMoves: ["cosmicpower", "psychoshift", "roost", "storedpower"],
		tier: "RU",
		doublesTier: "DUU",
	},
	yamask: {
		tier: "LC",
	},
	cofagrigus: {
		randomBattleMoves: ["haze", "hiddenpowerfighting", "nastyplot", "painsplit", "shadowball", "trickroom", "willowisp"],
		tier: "UU",
		doublesTier: "DUU",
	},
	tirtouga: {
		tier: "LC",
	},
	carracosta: {
		randomBattleMoves: ["aquajet", "earthquake", "icebeam", "shellsmash", "stealthrock", "stoneedge", "waterfall"],
		tier: "NU",
		doublesTier: "DUU",
	},
	archen: {
		tier: "LC",
	},
	archeops: {
		randomBattleMoves: ["acrobatics", "earthquake", "headsmash", "pluck", "roost", "stoneedge", "uturn"],
		tier: "RU",
		doublesTier: "DUU",
	},
	trubbish: {
		tier: "LC",
	},
	garbodor: {
		randomBattleMoves: ["drainpunch", "gunkshot", "haze", "painsplit", "spikes", "toxicspikes"],
		tier: "NU",
		doublesTier: "DUU",
	},
	zorua: {
		tier: "LC",
	},
	zoroark: {
		randomBattleMoves: ["darkpulse", "flamethrower", "focusblast", "nastyplot", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		randomBattleMoves: ["bulletseed", "rockblast", "tailslap", "uturn"],
		tier: "RU",
		doublesTier: "DUU",
	},
	gothita: {
		tier: "LC",
	},
	gothorita: {
		tier: "PUBL",
		doublesTier: "NFE",
	},
	gothitelle: {
		randomBattleMoves: ["calmmind", "hiddenpowerfighting", "psychic", "rest", "thunderbolt", "trick"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "PU",
		doublesTier: "NFE",
	},
	reuniclus: {
		randomBattleMoves: ["calmmind", "focusblast", "psychic", "recover", "shadowball", "trickroom"],
		tier: "OU",
		doublesTier: "DOU",
	},
	ducklett: {
		tier: "LC",
	},
	swanna: {
		randomBattleMoves: ["hurricane", "icebeam", "raindance", "roost", "surf"],
		tier: "PU",
		doublesTier: "DUU",
	},
	vanillite: {
		tier: "LC",
	},
	vanillish: {
		tier: "NFE",
	},
	vanilluxe: {
		randomBattleMoves: ["autotomize", "explosion", "flashcannon", "hiddenpowerground", "icebeam"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	deerling: {
		tier: "LC",
	},
	sawsbuck: {
		randomBattleMoves: ["doubleedge", "hornleech", "megahorn", "naturepower", "return", "substitute", "swordsdance"],
		tier: "NU",
		doublesTier: "DUU",
	},
	emolga: {
		randomBattleMoves: ["acrobatics", "encore", "roost", "thunderbolt", "toxic", "uturn"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	karrablast: {
		tier: "LC",
	},
	escavalier: {
		randomBattleMoves: ["ironhead", "megahorn", "pursuit", "return", "swordsdance"],
		tier: "RU",
		doublesTier: "DUU",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		randomBattleMoves: ["clearsmog", "gigadrain", "hiddenpowerfire", "spore", "stunspore", "synthesis"],
		tier: "RU",
		doublesTier: "DOU",
	},
	frillish: {
		tier: "LC",
	},
	jellicent: {
		randomBattleMoves: ["icebeam", "recover", "scald", "shadowball", "toxic", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	alomomola: {
		randomBattleMoves: ["protect", "scald", "toxic", "waterfall", "wish"],
		tier: "NU",
		doublesTier: "DUU",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		randomBattleMoves: ["bugbuzz", "gigadrain", "hiddenpowerice", "thunder", "voltswitch"],
		tier: "RU",
		doublesTier: "DUU",
	},
	ferroseed: {
		tier: "RU",
		doublesTier: "LC",
	},
	ferrothorn: {
		randomBattleMoves: ["gyroball", "leechseed", "powerwhip", "protect", "spikes", "stealthrock", "toxic"],
		tier: "OU",
		doublesTier: "DOU",
	},
	klink: {
		tier: "LC",
	},
	klang: {
		tier: "PU",
		doublesTier: "NFE",
	},
	klinklang: {
		randomBattleMoves: ["geargrind", "return", "shiftgear", "substitute", "wildcharge"],
		tier: "RU",
		doublesTier: "DUU",
	},
	tynamo: {
		tier: "LC",
	},
	eelektrik: {
		tier: "NFE",
	},
	eelektross: {
		randomBattleMoves: ["flamethrower", "gigadrain", "hiddenpowerice", "superpower", "thunderbolt", "uturn"],
		tier: "NU",
		doublesTier: "DUU",
	},
	elgyem: {
		tier: "LC",
	},
	beheeyem: {
		randomBattleMoves: ["hiddenpowerfighting", "psychic", "thunderbolt", "trick", "trickroom"],
		tier: "PU",
		doublesTier: "DUU",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		randomBattleMoves: ["calmmind", "energyball", "fireblast", "hiddenpowerfighting", "shadowball", "substitute"],
		tier: "UUBL",
		doublesTier: "DOU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "PU",
		doublesTier: "NFE",
	},
	haxorus: {
		randomBattleMoves: ["aquatail", "dragondance", "earthquake", "outrage", "superpower", "swordsdance"],
		tier: "(OU)",
		doublesTier: "DUU",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		randomBattleMoves: ["aquajet", "iciclecrash", "stoneedge", "superpower", "swordsdance"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	cryogonal: {
		randomBattleMoves: ["hiddenpowerfire", "icebeam", "rapidspin", "recover", "toxic"],
		tier: "RU",
		doublesTier: "DUU",
	},
	shelmet: {
		tier: "LC",
	},
	accelgor: {
		randomBattleMoves: ["bugbuzz", "encore", "focusblast", "gigadrain", "hiddenpowerrock", "spikes", "yawn"],
		tier: "RU",
		doublesTier: "DUU",
	},
	stunfisk: {
		randomBattleMoves: ["discharge", "earthpower", "foulplay", "rest", "scald", "sleeptalk", "stealthrock", "toxic"],
		tier: "PU",
		doublesTier: "DUU",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		randomBattleMoves: ["highjumpkick", "stoneedge", "substitute", "swordsdance", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	druddigon: {
		randomBattleMoves: ["dragontail", "earthquake", "glare", "outrage", "stealthrock", "suckerpunch", "superpower"],
		tier: "RU",
		doublesTier: "DUU",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		randomBattleMoves: ["drainpunch", "earthquake", "icepunch", "rockpolish", "shadowpunch", "stealthrock"],
		tier: "NU",
		doublesTier: "DUU",
	},
	pawniard: {
		tier: "LC",
	},
	bisharp: {
		randomBattleMoves: ["ironhead", "lowkick", "nightslash", "suckerpunch", "swordsdance"],
		tier: "UU",
		doublesTier: "DUU",
	},
	bouffalant: {
		randomBattleMoves: ["earthquake", "headcharge", "megahorn", "stoneedge", "swordsdance"],
		tier: "RU",
		doublesTier: "DUU",
	},
	rufflet: {
		tier: "LC",
	},
	braviary: {
		randomBattleMoves: ["bravebird", "bulkup", "return", "roost", "superpower", "uturn"],
		tier: "NU",
		doublesTier: "DUU",
	},
	vullaby: {
		tier: "LC",
	},
	mandibuzz: {
		randomBattleMoves: ["bravebird", "foulplay", "roost", "taunt", "toxic", "whirlwind"],
		tier: "NU",
		doublesTier: "DUU",
	},
	heatmor: {
		randomBattleMoves: ["fireblast", "gigadrain", "suckerpunch", "superpower"],
		tier: "(PU)",
		doublesTier: "DUU",
	},
	durant: {
		randomBattleMoves: ["honeclaws", "ironhead", "rockslide", "superpower", "xscissor"],
		tier: "RU",
		doublesTier: "DUU",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "PU",
		doublesTier: "NFE",
	},
	hydreigon: {
		randomBattleMoves: ["darkpulse", "dracometeor", "flamethrower", "focusblast", "roost", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		randomBattleMoves: ["bugbuzz", "fierydance", "fireblast", "gigadrain", "hiddenpowerground", "quiverdance", "roost"],
		tier: "OU",
		doublesTier: "DOU",
	},
	cobalion: {
		randomBattleMoves: ["closecombat", "hiddenpowerice", "ironhead", "stealthrock", "stoneedge", "swordsdance", "taunt", "thunderwave", "voltswitch"],
		tier: "UU",
		doublesTier: "DUU",
	},
	terrakion: {
		randomBattleMoves: ["closecombat", "earthquake", "quickattack", "stealthrock", "stoneedge", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	virizion: {
		randomBattleMoves: ["closecombat", "leafblade", "stoneedge", "swordsdance"],
		tier: "UU",
		doublesTier: "DUU",
	},
	tornadus: {
		randomBattleMoves: ["acrobatics", "bulkup", "focusblast", "heatwave", "hurricane", "superpower", "taunt", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	tornadustherian: {
		randomBattleMoves: ["focusblast", "heatwave", "hurricane", "superpower", "uturn"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	thundurus: {
		randomBattleMoves: ["focusblast", "hiddenpowerice", "nastyplot", "thunderbolt", "thunderwave", "voltswitch"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	thundurustherian: {
		randomBattleMoves: ["agility", "focusblast", "grassknot", "hiddenpowerice", "nastyplot", "thunderbolt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	reshiram: {
		randomBattleMoves: ["blueflare", "dracometeor", "roost", "stoneedge", "tailwind"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	zekrom: {
		randomBattleMoves: ["boltstrike", "dracometeor", "focusblast", "honeclaws", "outrage", "roost", "substitute", "voltswitch"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	landorus: {
		randomBattleMoves: ["earthpower", "focusblast", "psychic", "rockpolish", "rockslide", "sludgewave"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	landorustherian: {
		randomBattleMoves: ["earthquake", "rockpolish", "stealthrock", "stoneedge", "superpower", "swordsdance", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kyurem: {
		randomBattleMoves: ["dracometeor", "earthpower", "focusblast", "icebeam", "outrage", "roost", "substitute"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	kyuremblack: {
		randomBattleMoves: ["dragonclaw", "earthpower", "fusionbolt", "icebeam", "roost", "substitute"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kyuremwhite: {
		randomBattleMoves: ["dracometeor", "earthpower", "focusblast", "fusionflare", "icebeam", "roost", "substitute"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	keldeo: {
		randomBattleMoves: ["calmmind", "hiddenpowergrass", "hydropump", "icywind", "scald", "secretsword", "substitute"],
		tier: "OU",
		doublesTier: "DUU",
	},
	keldeoresolute: {
		tier: "OU",
		doublesTier: "DUU",
	},
	meloetta: {
		randomBattleMoves: ["calmmind", "focusblast", "psychic", "shadowball", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	meloettapirouette: {
		randomBattleMoves: ["closecombat", "icepunch", "relicsong", "return", "shadowclaw"],
	},
	genesect: {
		randomBattleMoves: ["bugbuzz", "flamethrower", "icebeam", "ironhead", "rockpolish", "thunderbolt", "uturn"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectdouse: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "(DOU)",
	},
	pokestarsmeargle: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarufo: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarufo2: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarbrycenman: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarmt: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarmt2: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestartransport: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestargiant: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestargiant2: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarhumanoid: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarmonster: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarf00: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarf002: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarspirit: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarblackdoor: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarwhitedoor: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarblackbelt: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestargiantpropo2: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	pokestarufopropu2: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
};
